import { render } from "./OrderRow.vue?vue&type=template&id=70158b01&scoped=true"
import script from "./OrderRow.vue?vue&type=script&lang=js"
export * from "./OrderRow.vue?vue&type=script&lang=js"

import "./OrderRow.vue?vue&type=style&index=0&id=70158b01&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70158b01"]])

export default __exports__